import { MouseEventHandler, ReactNode } from 'react';

import IconCircleCheck from 'approot/shared/icons/icon-circle-check';
import { ReactComponent as Indeterminate } from 'lib/form/checkbox-input/line.svg';
import { ReactComponent as Tick } from 'lib/form/checkbox-input/tick.svg';
import { DropdownOption } from './dropdown.constants';
import * as Styled from './dropdown-item.style';

export const DropdownItemRadio = ({
  label,
  isActive,
  onClick,
}: {
  label: string;
  isActive: boolean;
  onClick: MouseEventHandler;
}) => (
  <Styled.DropdownItemRadio
    $isActive={isActive}
    data-selector="dropdown-options"
    onClick={onClick}
  >
    <span>{label}</span>
    <IconCircleCheck width={16} height={16} />
  </Styled.DropdownItemRadio>
);

type CheckboxProps = {
  isIndeterminate?: boolean;
  className?: string;
};

export const DropdownCheckbox = ({
  isIndeterminate,
  className,
}: CheckboxProps) => (
  <Styled.CheckboxDecor className={className}>
    <div></div>
    {isIndeterminate ? <Indeterminate /> : <Tick />}
  </Styled.CheckboxDecor>
);

export const DropdownItemCheckbox = ({
  option,
  checked,
  isIndeterminate,
  handleSelect,
  ...rest
}: {
  option: DropdownOption;
  checked: boolean;
  handleSelect: () => void;
} & CheckboxProps) => (
  <Styled.DropdownSelectItem
    role="checkbox"
    aria-checked={checked}
    $checked={checked}
    onClick={handleSelect}
    {...rest}
  >
    <DropdownCheckbox isIndeterminate={isIndeterminate} />
    {option.description ? (
      <div>
        <Styled.DropdownItemDescription>
          {option.description}
        </Styled.DropdownItemDescription>
        <Styled.DropdownItemLabelStrong>
          {option.label}
        </Styled.DropdownItemLabelStrong>
      </div>
    ) : (
      <Styled.DropdownItemLabel>{option.label}</Styled.DropdownItemLabel>
    )}
  </Styled.DropdownSelectItem>
);

export const DropdownItemDescriptive = ({
  isActive,
  icon,
  content,
  primaryText,
  secondaryText,
  isDisabled,
  onClick,
  ...rest
}: {
  isActive?: boolean;
  content?: ReactNode;
  primaryText?: string;
  secondaryText?: string;
  icon?: ReactNode;
  isDisabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <Styled.DropdownItemFlex
      $isActive={isActive}
      onClick={onClick}
      aria-selected={isActive}
      disabled={isDisabled}
      {...rest}
    >
      {icon && (
        <Styled.DropdownItemIconWrapper>{icon}</Styled.DropdownItemIconWrapper>
      )}
      <div>
        {content ? (
          content
        ) : (
          <>
            {primaryText && (
              <Styled.DropdownItemLabelStrong>
                {primaryText}
              </Styled.DropdownItemLabelStrong>
            )}
            {secondaryText && (
              <Styled.DropdownItemDescription>
                {secondaryText}
              </Styled.DropdownItemDescription>
            )}
          </>
        )}
      </div>
    </Styled.DropdownItemFlex>
  );
};
